import { Pipe, PipeTransform } from '@angular/core';
import { Controller } from 'src/app/core/models/controller.model';
import { Location } from 'src/app/core/models/project/location.model';

@Pipe({
  name: 'getSelectedControllers',
})
export class GetSelectedControllersPipe implements PipeTransform {

  transform(location: Location, selectedControllers: Controller[]): Controller[] {
    // this pipe is used to get updated state from location to selected controllers, otherwise state does not update
    const conts = location?.controllers?.$values.filter((c)=> {
        return selectedControllers[0]?.id === c?.id;
      })
      return conts?conts:[]
  }

}
